document.addEventListener('DOMContentLoaded', function() {
    var carousel = document.querySelector('.pdm-category-carousel');
    
    if (carousel) {
        $(carousel).slick({
            arrows: false,
            dots: false,
            draggable: true,
            infinite: true,
            lazyLoad: 'ondemand',
            mobileFirst: true,
            swipe: true,
            swipeToSlide: true,
            touchMove: true,
            slidesToShow: 4,
            centerPadding: '16px',
            swipeToSlide: true,
            variableWidth: true,
        });
    };
});
